import $ from 'jquery'

export function throttle(cb, delay) {
  let wait = false

  return (...args) => {
    if (wait) {
      return
    }

    cb(...args)
    wait = true
    setTimeout(() => {
      wait = false
    }, delay)
  }
}

export function debounce(func, wait, immediate) {
  var timeout
  return function () {
    var context = this,
      args = arguments
    var later = function () {
      timeout = null
      if (!immediate) func.apply(context, args)
    }
    var callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) func.apply(context, args)
  }
}

export function isMobileBreakpoint() {
  return $('h1').css('font-size') !== '96px'
}

// Tracks the scroll position for when we lock/unlock
// window.addEventListener('scroll', () => {
//   document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`)
// })
